export enum ZoneActionTypes{
    API_RESPONSE_SUCCESS = '@@zone/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@zone/API_RESPONSE_ERROR',
    ADD_ZONE = '@@zone/ADD_ZONE',
    UPDATE_ZONE = '@@zone/UPDATE_ZONE',
    DELETE_ZONE = '@@zone/DELETE_ZONE',
    GET_AllZONES = '@@zone/GET_AllZONES',
}

